import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import DerbyHorse from "../components/betfair/DerbyHorse";
import BetfairTopNav from "./top-nav-betfair";
import "../../../assets/css/betfair_games.css";
import useSocket from "../../../hooks/useSocket";
import BetfairCasinoBetslipWeb from "./betfair_casino_betslip_web";
import "../../../assets/css/CardsSprite.css";
import "../../../assets/css/betfair_games_lo2.css";
import axiosInstance from "../../../utils/axiosInstance";
import TPPopUpBetSlip from "../tp-studio/teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

const BetfairTurboDerby = () => {
  const dispatch = useDispatch();
  const [getBetDelayTime, setGetBetDelayTime] = useState([]);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const [stakeList, setStakeList] = useState({});
  /**
 *
 *  rnr1_status: 'LOSER',
  rnr2_status: 'LOSER',
  rnr3_status: 'WINNER',
  rnr4_status: 'LOSER',
 */
  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [book5, setBook5] = useState("");
  const [book6, setBook6] = useState("");
  const [book7, setBook7] = useState("");
  const [book8, setBook8] = useState("");
  const [book9, setBook9] = useState("");

  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  let betfairOdds = null;
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "bfgames",
    type: "turbo_derby"
  });

  let evt_status = "";
  let market_status = "";
  let roundId = "";
  let timeLeft = "";
  let time_percentage = "";
  let round = "";
  let status = 1;
  let runner1b1 = 0;
  let runner1b2 = "";
  let runner1b3 = "";
  let runner1l1 = "";
  let runner1l2 = "";
  let runner1l3 = "";
  let runner2b1 = 0;
  let runner2b2 = "";
  let runner2b3 = "";
  let runner2l1 = "";
  let runner2l2 = "";
  let runner2l3 = "";
  let runner3b1 = 0;
  let runner3b2 = "";
  let runner3b3 = "";
  let runner3l1 = "";
  let runner3l2 = "";
  let runner3l3 = "";
  let runner4b1 = 0;
  let runner4b2 = "";
  let runner4b3 = "";
  let runner4l1 = "";
  let runner4l2 = "";
  let runner4l3 = "";
  let runner5b1 = "";
  let runner5b2 = "";
  let runner5b3 = "";
  let runner5l1 = "";
  let runner5l2 = "";
  let runner5l3 = "";
  let runner6b1 = "";
  let runner6b2 = "";
  let runner6b3 = "";
  let runner6l1 = "";
  let runner6l2 = "";
  let runner6l3 = "";
  let runner7b1 = "";
  let runner7b2 = "";
  let runner7b3 = "";
  let runner7l1 = "";
  let runner7l2 = "";
  let runner7l3 = "";
  let runner8b1 = "";
  let runner8b2 = "";
  let runner8b3 = "";
  let runner8l1 = "";
  let runner8l2 = "";
  let runner8l3 = "";
  let runner9b1 = "";
  let runner9b2 = "";
  let runner9b3 = "";
  let runner9l1 = "";
  let runner9l2 = "";
  let runner9l3 = "";

  let runner1b1_matched = "";
  let runner1b2_matched = "";
  let runner1b3_matched = "";
  let runner1l1_matched = "";
  let runner1l2_matched = "";
  let runner1l3_matched = "";
  let runner2b1_matched = "";
  let runner2b2_matched = "";
  let runner2b3_matched = "";
  let runner2l1_matched = "";
  let runner2l2_matched = "";
  let runner2l3_matched = "";
  let runner3b1_matched = "";
  let runner3b2_matched = "";
  let runner3b3_matched = "";
  let runner3l1_matched = "";
  let runner3l2_matched = "";
  let runner3l3_matched = "";
  let runner4b1_matched = "";
  let runner4b2_matched = "";
  let runner4b3_matched = "";
  let runner4l1_matched = "";
  let runner4l2_matched = "";
  let runner4l3_matched = "";
  let runner5b1_matched = "";
  let runner5b2_matched = "";
  let runner5b3_matched = "";
  let runner5l1_matched = "";
  let runner5l2_matched = "";
  let runner5l3_matched = "";
  let runner6b1_matched = "";
  let runner6b2_matched = "";
  let runner6b3_matched = "";
  let runner6l1_matched = "";
  let runner6l2_matched = "";
  let runner6l3_matched = "";
  let runner7b1_matched = "";
  let runner7b2_matched = "";
  let runner7b3_matched = "";
  let runner7l1_matched = "";
  let runner7l2_matched = "";
  let runner7l3_matched = "";
  let runner8b1_matched = "";
  let runner8b2_matched = "";
  let runner8b3_matched = "";
  let runner8l1_matched = "";
  let runner8l2_matched = "";
  let runner8l3_matched = "";
  let runner9b1_matched = "";
  let runner9b2_matched = "";
  let runner9b3_matched = "";
  let runner9l1_matched = "";
  let runner9l2_matched = "";
  let runner9l3_matched = "";

  let rnr1_status = "";
  let rnr2_status = "";
  let rnr3_status = "";
  let rnr4_status = "";
  let rnr5_status = "";
  let rnr6_status = "";
  let rnr7_status = "";
  let rnr8_status = "";
  let rnr9_status = "";

  let suspend1 = "";
  let suspend2 = "";
  let suspend3 = "";
  let suspend4 = "";
  let suspend5 = "";
  let suspend6 = "";
  let suspend7 = "";
  let suspend8 = "";
  let suspend9 = "";

  let cards_desc = "";
  let cardsDesc = "";

  let rnr1_desc = "";
  let rnr2_desc = "";
  let rnr3_desc = "";
  let rnr4_desc = "";

  let cardsDesc1 = "";
  let cardsDesc2 = "";
  let cardsDesc3 = "";
  let cardsDesc4 = "";
  let max = -219.99078369140625;

  let spades_desc = [];
  let hearts_desc = [];
  let clubs_desc = [];
  let diamonds_desc = [];

  let spadesDesc = [];
  let heartsDesc = [];
  let clubsDesc = [];
  let diamondsDesc = [];

  let spades_place = "";
  let hearts_place = "";
  let clubs_place = "";
  let diamonds_place = "";

  let spades_segment = "";
  let hearts_segment = "";
  let clubs_segment = "";
  let diamonds_segment = "";

  let current_desc = [];

  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  if (data != null && data.data !== null && data.data !== undefined) {
    betfairOdds = data.data;
    updateUserData(data?.user);
    roundId = betfairOdds.roundId;
    status = betfairOdds.status;

    //status = 3;
    market_status = betfairOdds.market_status;
    timeLeft = betfairOdds.timeLeft;
    time_percentage = betfairOdds.time_percentage;
    round = betfairOdds.round;

    runner1b1 = betfairOdds.runner1b1;
    runner1b2 = betfairOdds.runner1b2;
    runner1b3 = betfairOdds.runner1b3;
    runner1l1 = betfairOdds.runner1l1;
    runner1l2 = betfairOdds.runner1l2;
    runner1l3 = betfairOdds.runner1l3;
    runner2b1 = betfairOdds.runner2b1;
    runner2b2 = betfairOdds.runner2b2;
    runner2b3 = betfairOdds.runner2b3;
    runner2l1 = betfairOdds.runner2l1;
    runner2l2 = betfairOdds.runner2l2;
    runner2l3 = betfairOdds.runner2l3;
    runner3b1 = betfairOdds.runner3b1;
    runner3b2 = betfairOdds.runner3b2;
    runner3b3 = betfairOdds.runner3b3;
    runner3l1 = betfairOdds.runner3l1;
    runner3l2 = betfairOdds.runner3l2;
    runner3l3 = betfairOdds.runner3l3;
    runner4b1 = betfairOdds.runner4b1;
    runner4b2 = betfairOdds.runner4b2;
    runner4b3 = betfairOdds.runner4b3;
    runner4l1 = betfairOdds.runner4l1;
    runner4l2 = betfairOdds.runner4l2;
    runner4l3 = betfairOdds.runner4l3;

    runner1b1_matched = formatTruncate(betfairOdds?.runner1b1_matched);
    runner1b2_matched = formatTruncate(betfairOdds?.runner1b2_matched);
    runner1b3_matched = formatTruncate(betfairOdds?.runner1b3_matched);
    runner1l1_matched = formatTruncate(betfairOdds?.runner1l1_matched);
    runner1l2_matched = formatTruncate(betfairOdds?.runner1l2_matched);
    runner1l3_matched = formatTruncate(betfairOdds?.runner1l3_matched);
    runner2b1_matched = formatTruncate(betfairOdds?.runner2b1_matched);
    runner2b2_matched = formatTruncate(betfairOdds?.runner2b2_matched);
    runner2b3_matched = formatTruncate(betfairOdds?.runner2b3_matched);
    runner2l1_matched = formatTruncate(betfairOdds?.runner2l1_matched);
    runner2l2_matched = formatTruncate(betfairOdds?.runner2l2_matched);
    runner2l3_matched = formatTruncate(betfairOdds?.runner2l3_matched);
    runner3b1_matched = formatTruncate(betfairOdds?.runner3b1_matched);
    runner3b2_matched = formatTruncate(betfairOdds?.runner3b2_matched);
    runner3b3_matched = formatTruncate(betfairOdds?.runner3b3_matched);
    runner3l1_matched = formatTruncate(betfairOdds?.runner3l1_matched);
    runner3l2_matched = formatTruncate(betfairOdds?.runner3l2_matched);
    runner3l3_matched = formatTruncate(betfairOdds?.runner3l3_matched);
    runner4b1_matched = formatTruncate(betfairOdds?.runner4b1_matched);
    runner4b2_matched = formatTruncate(betfairOdds?.runner4b2_matched);
    runner4b3_matched = formatTruncate(betfairOdds?.runner4b3_matched);
    runner4l1_matched = formatTruncate(betfairOdds?.runner4l1_matched);
    runner4l2_matched = formatTruncate(betfairOdds?.runner4l2_matched);
    runner4l3_matched = formatTruncate(betfairOdds?.runner4l3_matched);

    rnr1_status = betfairOdds.rnr1_status;
    rnr2_status = betfairOdds.rnr2_status;
    rnr3_status = betfairOdds.rnr3_status;
    rnr4_status = betfairOdds.rnr4_status;

    suspend1 = betfairOdds.suspend1;
    suspend2 = betfairOdds.suspend2;
    suspend3 = betfairOdds.suspend3;
    suspend4 = betfairOdds.suspend4;
    suspend5 = betfairOdds.suspend5;
    suspend6 = betfairOdds.suspend6;
    suspend7 = betfairOdds.suspend7;
    suspend8 = betfairOdds.suspend8;
    suspend9 = betfairOdds.suspend9;

    evt_status = betfairOdds.evt_status;
    if (evt_status == "SUSPENDED_GAME_ROUND_OVER") {
      if (rnr1_status != "IN_PLAY") {
        rnr1_status = rnr1_status;
      } else {
        rnr1_status = "ROUND OVER !";
      }

      if (rnr2_status != "IN_PLAY") {
        rnr2_status = rnr2_status;
      } else {
        rnr2_status = "ROUND OVER !";
      }

      if (rnr3_status != "IN_PLAY") {
        rnr3_status = rnr3_status;
      } else {
        rnr3_status = "ROUND OVER !";
      }

      if (rnr4_status != "IN_PLAY") {
        rnr4_status = rnr4_status;
      } else {
        rnr4_status = "ROUND OVER !";
      }
    }

    spades_desc = betfairOdds.spades_desc;
    hearts_desc = betfairOdds.hearts_desc;
    clubs_desc = betfairOdds.clubs_desc;
    diamonds_desc = betfairOdds.diamonds_desc;

    spadesDesc = betfairOdds.spadesDesc;
    heartsDesc = betfairOdds.heartsDesc;
    clubsDesc = betfairOdds.clubsDesc;
    diamondsDesc = betfairOdds.diamondsDesc;

    spades_place = betfairOdds.spades_place;
    if (spades_place == "1") {
      spades_place = spades_place + "st";
    } else if (spades_place == "2") {
      spades_place = spades_place + "nd";
    } else if (spades_place == "3") {
      spades_place = spades_place + "rd";
    } else if (spades_place == "4") {
      spades_place = spades_place + "rth";
    }
    hearts_place = betfairOdds.hearts_place;
    if (hearts_place == "1") {
      hearts_place = hearts_place + "st";
    } else if (hearts_place == "2") {
      hearts_place = hearts_place + "nd";
    } else if (hearts_place == "3") {
      hearts_place = hearts_place + "rd";
    } else if (hearts_place == "4") {
      hearts_place = hearts_place + "rth";
    }
    clubs_place = betfairOdds.clubs_place;
    if (clubs_place == "1") {
      clubs_place = clubs_place + "st";
    } else if (clubs_place == "2") {
      clubs_place = clubs_place + "nd";
    } else if (clubs_place == "3") {
      clubs_place = clubs_place + "rd";
    } else if (clubs_place == "4") {
      clubs_place = clubs_place + "rth";
    }
    diamonds_place = betfairOdds.diamonds_place;
    if (diamonds_place == "1") {
      diamonds_place = diamonds_place + "st";
    } else if (diamonds_place == "2") {
      diamonds_place = diamonds_place + "nd";
    } else if (diamonds_place == "3") {
      diamonds_place = diamonds_place + "rd";
    } else if (diamonds_place == "4") {
      diamonds_place = diamonds_place + "rth";
    }

    spades_segment = betfairOdds.spades_segment;
    hearts_segment = betfairOdds.hearts_segment;
    clubs_segment = betfairOdds.clubs_segment;
    diamonds_segment = betfairOdds.diamonds_segment;

    current_desc = betfairOdds.current_desc;

    ///
    /*
    cards_desc = betfairOdds.cards_desc;
    cardsDesc = cards_desc.split(",");

    rnr1_desc = betfairOdds.rnr1_desc;
    cardsDesc1 = rnr1_desc.split(",");
    rnr2_desc = betfairOdds.rnr2_desc;
    cardsDesc2 = rnr2_desc.split(",");
    rnr3_desc = betfairOdds.rnr3_desc;
    cardsDesc3 = rnr3_desc.split(",");
    rnr4_desc = betfairOdds.rnr4_desc;
    cardsDesc4 = rnr4_desc.split(",");
    */
  }
  const getCardImage = (cardValue) => {
    if (cardValue === "NOT AVAILABLE") {
      return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
    }

    if (["28", "33", "39", "40"].includes(cardValue)) {
      return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
    }

    return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);

      setStakeList({
        stake1: data.response.stake1,
        stake2: data.response.stake2,
        stake3: data.response.stake3,
        stake4: data.response.stake4,
        stake5: data.response.stake5,
        stake6: data.response.stake6,
        stake7: data.response.stake7,
        stake8: data.response.stake8
      });
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  /// place bet ///

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    market_type
  ) => {
    if (price <= 0) {
      return;
    }
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "betfair_turbo_derby"
    };
    placeBetObject.catmid = roundId;
    placeBetObject.round = round;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = market_type;
    placeBetObject.game_type = 9;

    setPlaceBetObject(placeBetObject);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const getDelayTimes = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/event-limits");
      setGetBetDelayTime(data);
    } catch (error) {
      console.error("Failed to load getDelayTimes data:", error);
    }
  };

  const delayTime = (game_type) => {
    let defaultTime = 8;
    if (getBetDelayTime) {
      for (let i = 0; i < getBetDelayTime.response?.length; i++) {
        let obj = getBetDelayTime.response[i];
        if (obj.game_type == game_type) {
          defaultTime = obj.value;
          break;
        }
      }
    }

    return defaultTime;
  };

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
  const isProcessing = useRef(false);
  const [loading, setLoading] = useState(false);

  const placeBet = async (amount, profit) => {
    if (isProcessing.current) return;

    isProcessing.current = true;
    setLoading(true);
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    let delay = delayTime(7);
    console.log("delay->", delay);

    try {
      await sleep(delay * 1000);
      const response = await axiosInstance.post(
        "/betfair-turbo-derby",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        //toast.success(response.data.message);
        setShowBetSlipPopup(false);
        setBetErrorMessage(messageObj);
        //getBook(placeBetObject.catmid);
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
          //toast.error(errorMessage);
        }
      }
    } finally {
      isProcessing.current = false;
      setLoading(false);
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId;
    bookObject.game_type = "betfair-turbo-derby";

    const response = await axiosInstance.post("/betfair-book", bookObject);
    //console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let userbook2 = response.data.userbook2;
    let bet_list = response.data.bets_list;
    if (userbook && userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(() => {
    getDelayTimes();
  }, []);
  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  );

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "betfair-turbo-derby";

    const response = await axiosInstance.post("/betfair-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
    setShowResult(true);
  };

  const hideResultDetail = async () => {
    setShowResult(false);
  };

  ///
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: 8,
    minWidth: 180,
    boxSizing: "border-box"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 3,
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 40,
    height: 60,
    objectFit: "cover",
    borderRadius: 5
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };

  const horses = [
    {
      id: 0,
      runImage: "/assets/images/bpstudio/derby/green.gif",
      stillImage: "/assets/images/bpstudio/derby/green-still.png",
      position: runner1b1,
      isWinner: rnr1_status === "WINNER" ? true : false
    },
    {
      id: 1,
      runImage: "/assets/images/bpstudio/derby/red.gif",
      stillImage: "/assets/images/bpstudio/derby/red-still.png",
      position: runner2b1,
      isWinner: rnr2_status === "WINNER" ? true : false
    },
    {
      id: 2,
      runImage: "/assets/images/bpstudio/derby/blue.gif",
      stillImage: "/assets/images/bpstudio/derby/blue-still.png",
      position: runner3b1,
      isWinner: rnr3_status === "WINNER" ? true : false
    },
    {
      id: 3,
      runImage: "/assets/images/bpstudio/derby/yellow.gif",
      stillImage: "/assets/images/bpstudio/derby/yellow-still.png",
      position: runner4b1,
      isWinner: rnr4_status === "WINNER" ? true : false
    }
  ];
  const closeButton = () => {
    setShowModal(false);
  };

  const [isPageLoad, setIsPageLoad] = useState(false);
  useEffect(() => {
    if (data !== null && data !== undefined) {
      setIsPageLoad(true);
    }
  }, [data]);

  const getSpadesCard = (card_desc) => {
    cardsDesc1 = card_desc.split(",");
    let spadesCardArr = [];
    let heartCardArr = [];
    let clubCardArr = [];
    let diamondCardArr = [];

    for (let i = 0; i < cardsDesc1.length; i++) {
      let data = cardsDesc1[i];
      if (data >= 39 && data <= 51) {
        spadesCardArr.push(data);
      } else if (data >= 26 && data <= 38) {
        heartCardArr.push(data);
      } else if (data >= 0 && data <= 12) {
        clubCardArr.push(data);
      } else if (data >= 13 && data <= 25) {
        diamondCardArr.push(data);
      }
    }

    let returnData = {};
    returnData.spades = spadesCardArr;
    returnData.hearts = heartCardArr;
    returnData.clubs = clubCardArr;
    returnData.diamonds = diamondCardArr;

    return returnData;
  };

  const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <ClientLayout showLoader={false}>
      <style>
        {`
          .ExMainCardbundle .runner-position {
            bottom: 0px;
         }
          .ExMainCardbundle .runner-name {
              padding-top: 1px;
          }
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .sprite-card-chs-container {
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding: 4px;
        }
        .sprite-card-chs-suit-row {
          border-radius: 10px;
          border-bottom: solid;
          align-items: center;
          gap: 10px;
          display: inline-flex;
          flex-wrap: nowrap;
          justify-content: space-between;
        }
        .sprite-card-chs-suit-label {
          display: flex;
          align-items: center;
          width: max-content;
          font-weight: 700;
          flex-shrink: 0;
        }
        .sprite-card-chs-suit-label p{
          font-size: 12px;
          color: white;
        }
        .sprite-card-chs-cards {
          display: flex;
          overflow-x: hidden;
          overflow-y: hidden;
        }
        .sprite-card-chs-card {
          position: relative;
          display: flex;
          gap: 0;
          flex-shrink: 0;
          transform: scale(.8);
          transform-origin: left;
          margin-right: -10px;
        }
        .cross-overlay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 30px;
            color: red;
            font-weight: 700;
        }
        .trans_6 {
            transform: scale(.5) !important;
            margin-right: -22px !important;
        }
        .Derb-HC-cards-content {
          display: flex;
          background: 0 0;
          border-radius: 0 2px 2px 0;
          padding: 0;
          margin: -16px 0;
      }
          .modal-content-style {
          max-width: 1000px !important;
          width: 100% !important;
          max-height: 95vh !important;
          background-color: #ffffff !important;
          color: #000;
        }
        .card-header {
          padding: 0.75rem 1.25rem;
          margin-bottom: 0;
          background-color: unset;
           border-bottom: unset;
      }
            .tabcontent tbody tr {
              background:unset;
          }
        .no-border {
            border-bottom: none !important;
          }
            @media (max-width: 576px) {
            .players-table .suits-row {
              display: flex !important;
              flex-wrap: wrap !important;
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              justify-content: flex-start !important;
              align-items: stretch !important;
            }
            .players-table .suits-row > .TdResults {
              flex: 0 0 50% !important;
              width: 50% !important;
              max-width: 50% !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
            .players-table table tbody tr:nth-child(2) {
              display: flex !important;
              flex-wrap: wrap !important;
              width: 100% !important;
              box-sizing: border-box !important;
              padding-left: 5px !important;
              padding-right: 5px !important;
              margin: 0 !important;
              gap: 2px !important;
            }
            .players-table table tbody tr:nth-child(2) > td.TdResults {
              flex: 0 0 calc(50% - 1px) !important;
              width: calc(50% - 1px) !important;
              max-width: calc(50% - 1px) !important;
              min-width: 0 !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
            }
          }
          #ExgamesDiv > .col-lg-8.Exgamesbg {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }
        `}
      </style>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          background: "#ffffff"
        }}
      >
        <div className="ExMainCardbundle" style={{ marginBottom: "8px" }}>
          <div
            className="card-header"
            style={{
              background: "#ffffff",
              paddingBottom: "3px",
              paddingTop: "3px"
            }}
          >
            <BetfairTopNav></BetfairTopNav>
          </div>

          {!isPageLoad && (
            <div
              style={{
                zIndex: "1000",
                background: "#fff",
                width: "100%",
                height: "20%",
                opacity: 1,
                textAlign: "center"
              }}
            >
              <div>
                <img src="../assets/images/loadinggif.gif" alt="Loader" />
              </div>
            </div>
          )}

          <div
            className="card-body mainexcard"
            style={{ display: isPageLoad ? "block" : "none" }}
          >
            <div id="ExgamesDiv" className="row">
              <div className="col-lg-8 Exgamesbg">
                <div className="x-game-header">
                  <div className="container text-center">
                    <center className="row">
                      <div className="col-md-4 ExRounds">
                        <div className="round-counter-simple">
                          <div className="round-counter-text">
                            <span className="i18n">Round</span>
                          </div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 1 ? "active" : ""
                            }`}
                            id="roundCounter1"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 2 ? "active" : ""
                            }`}
                            id="roundCounter2"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 3 ? "active" : ""
                            }`}
                            id="roundCounter3"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 4 ? "active" : ""
                            }`}
                            id="roundCounter4"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 5 ? "active" : ""
                            }`}
                            id="roundCounter5"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 6 ? "active" : ""
                            }`}
                            id="roundCounter6"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 7 ? "active" : ""
                            }`}
                            id="roundCounter7"
                          ></div>
                        </div>
                      </div>
                      <div className="col-4 col-md-4">
                        <div id="demoTimer" className="col">
                          <div className="base-timer casino-timer">
                            <svg
                              className="progressBar"
                              x="0px"
                              y="0px"
                              viewBox="0 0 80 80"
                            >
                              <path
                                className="track"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                              />
                              <path
                                className="fill fill_green"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                style={{
                                  strokeDashoffset: ((30 - timeLeft) / 30) * max
                                }}
                              />
                              <text
                                className="value"
                                x="50%"
                                y="55%"
                                style={{
                                  fontSize: "30px",
                                  fontWeight: "bold"
                                }}
                              >
                                {timeLeft}
                              </text>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="col-8  col-md-4 inline-block Gameidcol">
                        Game ID:<span id="round-id">{roundId}</span>
                        <div
                          role="group"
                          aria-label="Second group"
                          className="btn-group btn-group-sm mr-2"
                        >
                          <button
                            type="button"
                            id="Alltab"
                            className={`tablink
                                                btn
                                                btn-primary
                                                 ${
                                                   showResult ? "" : "bbactive"
                                                 }`}
                            onClick={() => hideResultDetail()}
                          >
                            Game
                          </button>
                          <button
                            type="button"
                            id="RESULTStab"
                            className={`tablink
                                                btn
                                                btn-primary
                                                ${
                                                  showResult ? "bbactive" : ""
                                                }`}
                            onClick={() => showResultDetail()}
                          >
                            Results
                          </button>
                          <button
                            type="button"
                            className="tablink btn btn-primary "
                            data-toggle="modal"
                            data-target="#rulesPopup"
                            style={{ display: "inline-block" }}
                            onClick={() => setShowModal(true)}
                          >
                            Rules
                          </button>
                          {showModal && (
                            <div
                              class="modal fade show"
                              id="modalMarketRules"
                              tabindex="-1"
                              role="dialog"
                              aria-labelledby="modalMarketRules"
                              style={{ display: "block", paddingLeft: "0px" }}
                            >
                              <div
                                class="modal-dialog modal-lg"
                                role="document"
                              >
                                <div class="modal-content modal-content-style">
                                  <div
                                    class="modal-header"
                                    style={{
                                      borderBottom: "0px",
                                      padding: "5px",
                                      background: "#e0e0e0"
                                    }}
                                  >
                                    <div
                                      class="modal-title"
                                      id="exampleModalLabel"
                                      style={{
                                        fontSize: "20px",
                                        color: "rgba(0,0,0,.87)",
                                        margin: "5px 0px 0px 10px"
                                      }}
                                    >
                                      <b>Market Rules</b>
                                    </div>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      style={{
                                        color: "white",
                                        margin: "-0.5rem -0.7rem -1rem auto"
                                      }}
                                    >
                                      <span
                                        aria-hidden="true"
                                        style={{
                                          color: "#000",
                                          opacity: "0.8"
                                        }}
                                        onClick={closeButton}
                                      >
                                        ×
                                      </span>
                                    </button>
                                  </div>
                                  <div
                                    id="market-rules-text"
                                    class="modal-body"
                                  >
                                    <div
                                      class="text-block-renderer-component"
                                      style={{ textAlign: "left" }}
                                    >
                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="">
                                            What is Exchange Card Racing?
                                          </span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              Exchange Card Racing is a game of
                                              Virtual Racing offering a
                                              realistic racing experience. The
                                              players bet against each other on
                                              a bet exchange market. Just like
                                              betting on a horse race on
                                              Betfair.com, but here the race is
                                              simulated using a standard 52 card
                                              deck. The action never ends at
                                              Betfair Games with races running
                                              24/7.
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="i18n">
                                            Before the Race Starts
                                          </span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              Each race begins with four runners
                                              lined up at the starting line of a
                                              32 segment race track. Each runner
                                              is represented by a suit (Spades,
                                              Hearts, Clubs and Diamonds). A
                                              randomly shuffled pack of 52 cards
                                              is used to simulate the race. An
                                              exchange market where the players
                                              can place back and lay bets on the
                                              runners is available. The first
                                              round of betting occurs when all
                                              52 cards in the deck are still
                                              unseen and players can back or lay
                                              any of the 4 runners.
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="i18n">Handicaps</span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              At the end of the first round of
                                              betting any unmatched bets are
                                              cancelled. Now, before the race
                                              can start, the handicaps are
                                              determined. Three cards of each
                                              suit are randomly removed from the
                                              deck and turned face up. The
                                              remaining 40 cards in the deck
                                              will then be used for the race
                                              simulation. A second round of
                                              betting commences in which the
                                              players can place new bets based
                                              on the handicaps.
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="i18n">
                                            During the Race
                                          </span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              After the end of the second
                                              betting round, the race starts.
                                              Three cards will now be drawn from
                                              the deck, one by one and turned
                                              face up. After each card is turned
                                              over, the runner of the
                                              corresponding suit moves forward
                                              according to the rank of the card
                                              (the card values are the same as
                                              in the game of Blackjack with Ace
                                              always ranked 11):
                                            </span>
                                          </p>
                                          <ul>
                                            <li>
                                              <span class="i18n">
                                                If the card ranks 2 to 10 the
                                                runner moves as many segments as
                                                the value of the card.
                                              </span>
                                            </li>
                                            <li>
                                              <span class="i18n">
                                                If it is a face card (Jack,
                                                Queen or King) the runner moves
                                                10 segments forward.
                                              </span>
                                            </li>
                                            <li>
                                              <span class="i18n">
                                                If the card is an Ace the runner
                                                moves 11 segments forward.
                                              </span>
                                            </li>
                                          </ul>
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              After all three cards have been
                                              drawn and the runners have been
                                              moved forward it is time for the
                                              next betting round.
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="i18n">The Winner</span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              The race action will now continue
                                              with three cards being drawn
                                              between each betting round until
                                              one runner crosses the finishing
                                              line. Note that as soon as a
                                              runner crosses the finishing line
                                              (i.e. reaches the 32nd segment of
                                              the race track) the race is over
                                              and no more cards will be drawn.
                                              Therefore it is not possible for a
                                              dead heat to occur. The market for
                                              Exchange Card Derby Racing is
                                              always settled with one single
                                              winner.
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div class="section">
                                        <h2 class="section-title">
                                          <span class="i18n">
                                            The Betting Round Timer
                                          </span>
                                        </h2>
                                        <div class="section-content">
                                          <p class="paragraph">
                                            <span class="i18n text">
                                              In the top right corner of the
                                              race track view you find the
                                              betting round timer. You can see
                                              which betting round you are in to
                                              the left of the timer. When a
                                              round is open for betting the
                                              timer turns green. The timer then
                                              gives an indication of how much
                                              time remains of the current
                                              betting round. Bear in mind that
                                              this is an indication only, always
                                              make sure that you place your bets
                                              in time. Once betting is closed
                                              the timer turns red.
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </center>
                  </div>
                </div>
                <div
                  id="AlltabData"
                  className="tabcontent"
                  style={{ display: showResult ? "none" : "contents" }}
                >
                  <div className="left-content">
                    {/**Horse component */}
                    <DerbyHorse
                      status={status}
                      round={round}
                      handicapCards={[]}
                      drawnCards={[
                        "svg-card_simple_0",
                        "svg-card_simple_25",
                        "svg-card_simple_33"
                      ]}
                      horses={horses}
                      spades_desc={spades_desc}
                      hearts_desc={hearts_desc}
                      clubs_desc={clubs_desc}
                      diamonds_desc={diamonds_desc}
                      current_desc={current_desc}
                    />
                    <center>
                      <div
                        className="progress"
                        style={{
                          height: "3px",
                          maxWidth: "50%",
                          marginBottom: "8px"
                        }}
                      >
                        <div
                          id="Exgamesprogress"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          className="progress-bar bg-danger"
                          style={{ width: "0%" }}
                          sid="roundProgressWidth"
                        ></div>
                      </div>
                    </center>
                    <div className="section-blur">
                      <div className="market-titlebar">
                        <p className="market-name"></p>
                        <div className="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div className="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b1status">
                          <h3
                            className={`runner-name ${
                              rnr1_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Spades
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus1">
                                    {book1 !== "" ? (
                                      Number(book1) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book1)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book1)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b3span"
                            data-teamname="Spades"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Spades",
                                "3",
                                runner1b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b3">
                              {runner1b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b3_matched"
                            >
                              {runner1b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b2span"
                            data-teamname="Spades"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Spades",
                                "2",
                                runner1b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b2">
                              {runner1b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b2_matched"
                            >
                              {runner1b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr1_status span1details"
                            id="runner1b1span"
                            data-teamname="Spades"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Spades",
                                "1",
                                runner1b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1b1">
                              {runner1b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b1_matched"
                            >
                              {runner1b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr1_status span1details"
                            id="runner1l1span"
                            data-teamname="Spades"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Spades",
                                "1",
                                runner1l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l1">
                              {runner1l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l1_matched"
                            >
                              {runner1l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l2span"
                            data-teamname="Spades"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Spades",
                                "2",
                                runner1l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l2">
                              {runner1l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l2_matched"
                            >
                              {runner1l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l3span"
                            data-teamname="Spades"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Spades",
                                "3",
                                runner1l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner1l3">
                              {runner1l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1l3_matched"
                            >
                              {runner1l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr1_status"
                            style={{
                              display:
                                suspend1 != 0 ||
                                rnr1_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr1_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b2status">
                          <h3
                            className={`runner-name ${
                              rnr2_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Hearts
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus2">
                                    {book2 !== "" ? (
                                      Number(book2) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book2)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book2)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b3span"
                            data-teamname="Hearts"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hearts",
                                "3",
                                runner2b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b3">
                              {runner2b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b3_matched"
                            >
                              {runner2b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b2span"
                            data-teamname="Hearts"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hearts",
                                "2",
                                runner2b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b2">
                              {runner2b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b2_matched"
                            >
                              {runner2b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr2_status span1details"
                            id="runner2b1span"
                            data-teamname="Hearts"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Hearts",
                                "1",
                                runner2b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2b1">
                              {runner2b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b1_matched"
                            >
                              {runner2b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr2_status span1details"
                            id="runner2l1span"
                            data-teamname="Hearts"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hearts",
                                "1",
                                runner2l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l1">
                              {runner2l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l1_matched"
                            >
                              {runner2l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l2span"
                            data-teamname="Hearts"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hearts",
                                "2",
                                runner2l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l2">
                              {runner2l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l2_matched"
                            >
                              {runner2l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l3span"
                            data-teamname="Hearts"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Hearts",
                                "3",
                                runner2l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner2l3">
                              {runner2l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l3_matched"
                            >
                              {runner2l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr2_status"
                            style={{
                              display:
                                suspend2 != 0 ||
                                rnr2_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr2_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b3status">
                          <h3
                            className={`runner-name ${
                              rnr3_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Clubs
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus3">
                                    {book3 !== "" ? (
                                      Number(book3) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book3)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book3)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b3span"
                            data-teamname="Clubs"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Clubs",
                                "3",
                                runner3b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b3">
                              {runner3b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b3_matched"
                            >
                              {runner3b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b2span"
                            data-teamname="Clubs"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Clubs",
                                "2",
                                runner3b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b2">
                              {runner3b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b2_matched"
                            >
                              {runner3b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr3_status span1details"
                            id="runner3b1span"
                            data-teamname="Clubs"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Clubs",
                                "1",
                                runner3b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3b1">
                              {runner3b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b1_matched"
                            >
                              {runner3b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr3_status span1details"
                            id="runner3l1span"
                            data-teamname="Clubs"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Clubs",
                                "1",
                                runner3l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l1">
                              {runner3l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l1_matched"
                            >
                              {runner3l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l2span"
                            data-teamname="Clubs"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Clubs",
                                "2",
                                runner3l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l2">
                              {runner3l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l2_matched"
                            >
                              {runner3l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l3span"
                            data-teamname="Clubs"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Clubs",
                                "3",
                                runner3l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner3l3">
                              {runner3l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l3_matched"
                            >
                              {runner3l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr3_status"
                            style={{
                              display:
                                suspend3 != 0 ||
                                rnr3_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr3_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b4status">
                          <h3
                            className={`runner-name ${
                              rnr4_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Diamonds
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus4">
                                    {book4 !== "" ? (
                                      Number(book4) > 0 ? (
                                        <font color="green">
                                          {formatTruncate(book4)}
                                        </font>
                                      ) : (
                                        <font color="red">
                                          {formatTruncate(book4)}
                                        </font>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b3span"
                            data-teamname="Diamonds"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Diamonds",
                                "3",
                                runner4b3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b3">
                              {runner4b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b3_matched"
                            >
                              {runner4b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b2span"
                            data-teamname="Diamonds"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Diamonds",
                                "2",
                                runner4b2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b2">
                              {runner4b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b2_matched"
                            >
                              {runner4b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr4_status span1details"
                            id="runner4b1span"
                            data-teamname="Diamonds"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Diamonds",
                                "1",
                                runner4b1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4b1">
                              {runner4b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b1_matched"
                            >
                              {runner4b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr4_status span1details"
                            id="runner4l1span"
                            data-teamname="Diamonds"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Diamonds",
                                "1",
                                runner4l1,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l1">
                              {runner4l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l1_matched"
                            >
                              {runner4l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l2span"
                            data-teamname="Diamonds"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Diamonds",
                                "2",
                                runner4l2,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l2">
                              {runner4l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l2_matched"
                            >
                              {runner4l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l3span"
                            data-teamname="Diamonds"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Diamonds",
                                "3",
                                runner4l3,
                                1
                              )
                            }
                            market_type="1"
                          >
                            <span className="price-odd" id="runner4l3">
                              {runner4l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l3_matched"
                            >
                              {runner4l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr4_status"
                            style={{
                              display:
                                suspend4 != 0 ||
                                rnr4_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr4_status}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="sprite-card-chs-container">
                      <div className="sprite-card-chs-suit-row sprite-card-chs-spades">
                        <div className="sprite-card-chs-suit-label">
                          <img src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_spades.svg?v=1233" />
                          <p style={{ margin: "2px" }}>
                            {spades_place}, {spades_segment} to go
                          </p>
                        </div>
                        <div className="sprite-card-chs-cards">
                          {spadesDesc &&
                            spadesDesc.length > 0 &&
                            spadesDesc.map((card, index) => {
                              const cardClass = `sprite-card-chs-card svg-card_simple_1-dims svg-card_simple_${card.data}`;
                              const valSpan =
                                card.val == 1 ? (
                                  ""
                                ) : (
                                  <span className="cross-overlay">✕</span>
                                );
                              return (
                                <span className={cardClass}>{valSpan}</span>
                              );
                            })}
                        </div>
                      </div>
                      <div className="sprite-card-chs-suit-row sprite-card-chs-hearts">
                        <div className="sprite-card-chs-suit-label">
                          <img src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_hearts.svg?v=1233" />
                          <p style={{ margin: "2px" }}>
                            {hearts_place}, {hearts_segment} to go
                          </p>
                        </div>
                        <div className="sprite-card-chs-cards">
                          {heartsDesc &&
                            heartsDesc.length > 0 &&
                            heartsDesc.map((card, index) => {
                              const cardClass = `sprite-card-chs-card svg-card_simple_1-dims svg-card_simple_${card.data}`;
                              const valSpan =
                                card.val == 1 ? (
                                  ""
                                ) : (
                                  <span className="cross-overlay">✕</span>
                                );
                              return (
                                <span className={cardClass}>{valSpan}</span>
                              );
                            })}
                        </div>
                      </div>
                      <div className="sprite-card-chs-suit-row sprite-card-chs-clubs">
                        <div className="sprite-card-chs-suit-label">
                          <img src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_clubs.svg?v=1233" />
                          <p style={{ margin: "2px" }}>
                            {clubs_place}, {clubs_segment} to go
                          </p>
                        </div>
                        <div className="sprite-card-chs-cards">
                          {clubsDesc &&
                            clubsDesc.length > 0 &&
                            clubsDesc.map((card, index) => {
                              const cardClass = `sprite-card-chs-card svg-card_simple_1-dims svg-card_simple_${card.data}`;
                              const valSpan =
                                card.val == 1 ? (
                                  ""
                                ) : (
                                  <span className="cross-overlay">✕</span>
                                );
                              return (
                                <span className={cardClass}>{valSpan}</span>
                              );
                            })}
                        </div>
                      </div>
                      <div className="sprite-card-chs-suit-row sprite-card-chs-diamonds">
                        <div className="sprite-card-chs-suit-label">
                          <img src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/icon_card_diamonds.svg?v=1233" />
                          <p style={{ margin: "2px" }}>
                            {diamonds_place}, {diamonds_segment} to go
                          </p>
                        </div>
                        <div className="sprite-card-chs-cards">
                          {diamondsDesc &&
                            diamondsDesc.length > 0 &&
                            diamondsDesc.map((card, index) => {
                              const cardClass = `sprite-card-chs-card svg-card_simple_1-dims svg-card_simple_${card.data}`;
                              const valSpan =
                                card.val == 1 ? (
                                  ""
                                ) : (
                                  <span className="cross-overlay">✕</span>
                                );
                              return (
                                <span className={cardClass}>{valSpan}</span>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="ResultsData"
                  className="tabcontent"
                  style={{ display: showResult ? "contents" : "none" }}
                >
                  {resultData &&
                    resultData.length > 0 &&
                    resultData.map((dataObj, index) => {
                      let win1 = dataObj.rnr1_status;
                      let win2 = dataObj.rnr2_status;
                      let win3 = dataObj.rnr3_status;
                      let win4 = dataObj.rnr4_status;

                      let spadesCard = getSpadesCard(dataObj.handicap_desc[0]);
                      let spades = spadesCard.spades;
                      let hearts = spadesCard.hearts;
                      let clubs = spadesCard.clubs;
                      let diamonds = spadesCard.diamonds;

                      let bgCls1 = win1 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls2 = win2 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls3 = win3 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls4 = win4 == "WINNER" ? "bgwinner" : "bgLoser";

                      let tdCls1 = win1 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls2 = win2 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls3 = win3 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls4 = win4 == "WINNER" ? "TdResultsWin" : "";

                      //let cardsArr = dataObj.cards_desc.split(",");
                      //let rnr1Arr = dataObj.rnr1_desc.split(",");
                      //let rnr2Arr = dataObj.rnr2_desc.split(",");
                      //let rnr3Arr = dataObj.rnr3_desc.split(",");
                      //let rnr4Arr = dataObj.rnr4_desc.split(",");
                      return (
                        <div class="left-content">
                          <div
                            class="card"
                            style={{
                              border: "1px solid rgb(204, 204, 204)",
                              borderRadius: "8px",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                              marginBottom: "5px",
                              background:
                                "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                              color: "white"
                            }}
                          >
                            <div
                              class="card-header no-border"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "5px",
                                marginTop: "5px",
                                marginLeft: "5px"
                              }}
                            >
                              {formatResultDate(dataObj.evt_od)} - <b>ID=</b>{" "}
                              {dataObj._id}
                            </div>{" "}
                            <div
                              class="card-body"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "0px",
                                marginBottom: "8px"
                              }}
                            >
                              <div
                                class="players-table"
                                style={{ textAlign: "center", width: "100%" }}
                              >
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse"
                                  }}
                                >
                                  <tbody>
                                    <tr
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "space-evenly"
                                      }}
                                    ></tr>{" "}
                                    <tr
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "space-evenly"
                                      }}
                                    >
                                      <td
                                        class={
                                          dataObj.rnr1_status == "WINNER"
                                            ? "TdResults TdResultsWin"
                                            : "TdResults"
                                        }
                                      >
                                        <div
                                          class="player-cards"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            overflowWrap: "break-word"
                                          }}
                                        >
                                          <div
                                            class="player-name"
                                            style={{
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            Spades
                                          </div>{" "}
                                          <div
                                            class="card-images"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              flexWrap: "wrap",
                                              width: "100%"
                                            }}
                                          >
                                            {spades &&
                                              spades.length > 0 &&
                                              spades.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);

                                                const cardClass = `card${
                                                  index + 1
                                                }in4`;
                                                return (
                                                  <div
                                                    style={{
                                                      transform: "unset",
                                                      transformOrigin: "unset"
                                                    }}
                                                    key={index}
                                                    id="BFBCardView"
                                                  >
                                                    <img
                                                      src={cardImage}
                                                      alt={`Card ${card}`}
                                                      style={{
                                                        width: "37px",
                                                        heigth: "45px"
                                                      }}
                                                    />
                                                  </div>
                                                );
                                              })}
                                          </div>{" "}
                                          <div
                                            class={
                                              dataObj.rnr1_status == "WINNER"
                                                ? "player-status bgwinner"
                                                : "player-status bgLoser"
                                            }
                                            style={{
                                              color: "rgb(0, 0, 0)",
                                              marginTop: "5px",
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            {dataObj.rnr1_status}
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        class={
                                          dataObj.rnr2_status == "WINNER"
                                            ? "TdResults TdResultsWin"
                                            : "TdResults"
                                        }
                                      >
                                        <div
                                          class="player-cards"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            overflowWrap: "break-word"
                                          }}
                                        >
                                          <div
                                            class="player-name"
                                            style={{
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            Hearts
                                          </div>{" "}
                                          <div
                                            class="card-images"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              flexWrap: "wrap",
                                              width: "100%"
                                            }}
                                          >
                                            {hearts &&
                                              hearts.length > 0 &&
                                              hearts.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);

                                                const cardClass = `card${
                                                  index + 1
                                                }in4`;
                                                return (
                                                  <div
                                                    style={{
                                                      transform: "unset",
                                                      transformOrigin: "unset"
                                                    }}
                                                    key={index}
                                                    id="BFBCardView"
                                                  >
                                                    <img
                                                      src={cardImage}
                                                      alt={`Card ${card}`}
                                                      style={{
                                                        width: "37px",
                                                        heigth: "45px"
                                                      }}
                                                    />
                                                  </div>
                                                );
                                              })}
                                          </div>{" "}
                                          <div
                                            class={
                                              dataObj.rnr2_status == "WINNER"
                                                ? "player-status bgwinner"
                                                : "player-status bgLoser"
                                            }
                                            style={{
                                              color: "rgb(0, 0, 0)",
                                              marginTop: "5px",
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            {dataObj.rnr2_status}
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        class={
                                          dataObj.rnr3_status == "WINNER"
                                            ? "TdResults TdResultsWin"
                                            : "TdResults"
                                        }
                                      >
                                        <div
                                          class="player-cards"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            overflowWrap: "break-word"
                                          }}
                                        >
                                          <div
                                            class="player-name"
                                            style={{
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            Clubs
                                          </div>{" "}
                                          <div
                                            class="card-images"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              flexWrap: "wrap",
                                              width: "100%"
                                            }}
                                          >
                                            {clubs &&
                                              clubs.length > 0 &&
                                              clubs.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);

                                                const cardClass = `card${
                                                  index + 1
                                                }in4`;
                                                return (
                                                  <div
                                                    style={{
                                                      transform: "unset",
                                                      transformOrigin: "unset"
                                                    }}
                                                    key={index}
                                                    id="BFBCardView"
                                                  >
                                                    <img
                                                      src={cardImage}
                                                      alt={`Card ${card}`}
                                                      style={{
                                                        width: "37px",
                                                        heigth: "45px"
                                                      }}
                                                    />
                                                  </div>
                                                );
                                              })}
                                          </div>{" "}
                                          <div
                                            class={
                                              dataObj.rnr3_status == "WINNER"
                                                ? "player-status bgwinner"
                                                : "player-status bgLoser"
                                            }
                                            style={{
                                              color: "rgb(0, 0, 0)",
                                              marginTop: "5px",
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            {dataObj.rnr3_status}
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        class={
                                          dataObj.rnr4_status == "WINNER"
                                            ? "TdResults TdResultsWin"
                                            : "TdResults"
                                        }
                                      >
                                        <div
                                          class="player-cards"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            overflowWrap: "break-word"
                                          }}
                                        >
                                          <div
                                            class="player-name"
                                            style={{
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            Diamonds
                                          </div>{" "}
                                          <div
                                            class="card-images"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              flexWrap: "wrap",
                                              width: "100%"
                                            }}
                                          >
                                            {diamonds &&
                                              diamonds.length > 0 &&
                                              diamonds.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);

                                                const cardClass = `card${
                                                  index + 1
                                                }in4`;
                                                return (
                                                  <div
                                                    style={{
                                                      transform: "unset",
                                                      transformOrigin: "unset"
                                                    }}
                                                    key={index}
                                                    id="BFBCardView"
                                                  >
                                                    <img
                                                      src={cardImage}
                                                      alt={`Card ${card}`}
                                                      style={{
                                                        width: "37px",
                                                        heigth: "45px"
                                                      }}
                                                    />
                                                  </div>
                                                );
                                              })}
                                          </div>{" "}
                                          <div
                                            class={
                                              dataObj.rnr4_status == "WINNER"
                                                ? "player-status bgwinner"
                                                : "player-status bgLoser"
                                            }
                                            style={{
                                              color: "rgb(0, 0, 0)",
                                              marginTop: "5px",
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              width: "100%"
                                            }}
                                          >
                                            {dataObj.rnr4_status}
                                          </div>
                                        </div>
                                      </td>{" "}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                className="col-lg-4"
                style={{ paddingLeft: "1px", paddingRight: "1px" }}
              >
                <div className="right-content">
                  <div>
                    {showBetSlipPopup && (
                      <TPPopUpBetSlip
                        closeBetSlipParent={closeBetSlipMobile}
                        betObj={placeBetObject}
                        placeBetParent={placeBet}
                        betButtonShow={betButtonShow}
                        loading={loading}
                        betErrorMessageObj={betErrorMessageObj}
                        betButtonShowLoaderShow={betButtonShowLoaderShow}
                        profileData={profileData}
                        stakeList={stakeList}
                      />
                    )}
                    <BetfairCasinoBetslipWeb
                      showBetSlip={showBetSlip}
                      placeBetObject={placeBetObject}
                      loading={loading}
                      closeBetSlipParent={closeBetSlip}
                      placeBetParent={placeBet}
                      betErrorMessageObj={betErrorMessageObj}
                      stakeList={stakeList}
                    ></BetfairCasinoBetslipWeb>
                    <div className="bets">
                      <strong style={{ color: "white" }}>
                        Matched Bets ({totalBets})
                      </strong>
                      <div className="betting-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Runner</th>
                              <th>Price</th>
                              <th>Size</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody id="refreshhistory">
                            {betList.length > 0 ? (
                              betList.map((item, index) => (
                                <tr
                                  style={{
                                    background:
                                      item.type == "b" ? "#e9f6fc" : "#fce3e4",
                                    color: "#000",
                                    fontSize: "15px",
                                    textAlign: "center"
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "15px",
                                      display: "table-cell",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rnr !== "" ? (
                                      item.rnr == "runner1b1" ||
                                      item.rnr == "runner1b2" ||
                                      item.rnr == "runner1b3" ||
                                      item.rnr == "runner1l1" ||
                                      item.rnr == "runner1l2" ||
                                      item.rnr == "runner1l3" ? (
                                        <span>Spades</span>
                                      ) : item.rnr == "runner2b1" ||
                                        item.rnr == "runner2b2" ||
                                        item.rnr == "runner2b3" ||
                                        item.rnr == "runner2l1" ||
                                        item.rnr == "runner2l2" ||
                                        item.rnr == "runner2l3" ? (
                                        <span>Hearts</span>
                                      ) : item.rnr == "runner3b1" ||
                                        item.rnr == "runner3b2" ||
                                        item.rnr == "runner3b3" ||
                                        item.rnr == "runner3l1" ||
                                        item.rnr == "runner3l2" ||
                                        item.rnr == "runner3l3" ? (
                                        <span>Clubs</span>
                                      ) : item.rnr == "runner4b1" ||
                                        item.rnr == "runner4b2" ||
                                        item.rnr == "runner4b3" ||
                                        item.rnr == "runner4l1" ||
                                        item.rnr == "runner4l2" ||
                                        item.rnr == "runner4l3" ? (
                                        <span>Diamonds</span>
                                      ) : item.rnr == "runner5b1" ||
                                        item.rnr == "runner5b2" ||
                                        item.rnr == "runner5b3" ||
                                        item.rnr == "runner5l1" ||
                                        item.rnr == "runner5l2" ||
                                        item.rnr == "runner5l3" ? (
                                        <span>Winner has FH or better</span>
                                      ) : item.rnr == "runner6b1" ||
                                        item.rnr == "runner6b2" ||
                                        item.rnr == "runner6b3" ||
                                        item.rnr == "runner6l1" ||
                                        item.rnr == "runner6l2" ||
                                        item.rnr == "runner6l3" ? (
                                        <span>Winner has Flush</span>
                                      ) : item.rnr == "runner7b1" ||
                                        item.rnr == "runner7b2" ||
                                        item.rnr == "runner7b3" ||
                                        item.rnr == "runner7l1" ||
                                        item.rnr == "runner7l2" ||
                                        item.rnr == "runner7l3" ? (
                                        <span>Winner has Straight</span>
                                      ) : item.rnr == "runner8b1" ||
                                        item.rnr == "runner8b2" ||
                                        item.rnr == "runner8b3" ||
                                        item.rnr == "runner8l1" ||
                                        item.rnr == "runner8l2" ||
                                        item.rnr == "runner8l3" ? (
                                        <span>Winner has Three of a Kind</span>
                                      ) : item.rnr == "runner9b1" ||
                                        item.rnr == "runner9b2" ||
                                        item.rnr == "runner9b3" ||
                                        item.rnr == "runner9l1" ||
                                        item.rnr == "runner9l2" ||
                                        item.rnr == "runner9l3" ? (
                                        <span>
                                          Winner has Two Pair or worse
                                        </span>
                                      ) : (
                                        <span></span> // For any other value
                                      )
                                    ) : (
                                      <span></span>
                                    )}
                                    - {item.cat_mid}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rate}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.amnt}
                                  </td>
                                  <td></td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </ClientLayout>
  );
};

export default BetfairTurboDerby;
